module.exports = __webpack_public_path__ + "static/img/20.0053798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/20.png
// module id = Nvfj
// module chunks = 1